import { FunctionComponent, ReactElement } from 'react';
import LocationsManagement, { LocationsManagementProps } from './LocationsManagement';

const RootLocationManagement: FunctionComponent<LocationsManagementProps> = (
	props
): ReactElement => (
	<LocationsManagement
		{...{
			...props,
			parentLocationId: undefined,
			header: { ...props.header, controlLocationsTemplate: true },
		}}
	/>
);

export default RootLocationManagement;
